import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { AiButtonOpenChat } from '../ai-button-open-chat/AiButtonOpenChat'
import { Z_INDEX_THIRD } from '../../../../src/legacy/common/theme'
import { useFooterState } from '../ai-button/useFooterRegistration'
import { useDashMessages } from '../../../intl/intl.hooks'

const slideIn = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(20px)',
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)',
  },
})

const FloatingButtonContainer = styled.div<{ hasFooterBeneath: boolean }>(
  ({ hasFooterBeneath }) => ({
    position: 'fixed',
    bottom: hasFooterBeneath ? '84px' : '24px',
    right: '24px',
    zIndex: Z_INDEX_THIRD,
    animation: `${slideIn} 300ms ease-out`,
  })
)

export const AiButtonFloating: React.FC = () => {
  const { hasFooter: hasFooterBeneath } = useFooterState()
  const intlMessages = useDashMessages({
    ariaLabel: 'aiButtonFloating.ariaLabel',
  })

  return (
    <FloatingButtonContainer
      hasFooterBeneath={hasFooterBeneath}
      data-has-footer-beneath={hasFooterBeneath}
    >
      <AiButtonOpenChat aria-label={intlMessages.ariaLabel} />
    </FloatingButtonContainer>
  )
}
